import { firmaCursosApi } from "../view/firmaDeCursos";
import {
  buildFiltersUrl,
  reshape_response,
} from "../../../../../helpers/functions";

export const getFirmaCursos = firmaCursosApi.injectEndpoints({
  endpoints: (builder) => ({
    getFirmaCursos: builder.query({
      query: ({ filter_params }) => ({
        url: buildFiltersUrl("/v1/api/firmaconstanciacurso/", filter_params),
        method: "GET",
      }),
      providesTags: (result) =>
        Array.isArray(result)
          ? [
              ...result.map(({ id }) => ({
                type: "FirmaCursos",
                id,
              })),
              { type: "FirmaCursos", id: "LIST" },
            ]
          : [{ type: "FirmaCursos", id: "LIST" }],
      transformResponse: (response, meta, args) => {
        if (Array.isArray(response)) {
          return response?.map((el) => reshape_response(el, args.shape));
        } else {
          const resultsTransformed = response?.results?.map((el) =>
            reshape_response(el, args.shape)
          );
          return {
            results: resultsTransformed,
            count: response.count,
            next: response.next,
            previous: response.previous,
          };
        }
      },
    }),
  }),
});

export const { useGetFirmaCursosQuery } = getFirmaCursos;
